import config from '../config';

// Auto-incrementing stats calculator
// Base date: Today's date (when the system was deployed)
// Update REACT_APP_STATS_BASE_DATE in .env to deployment date
const BASE_DATE = new Date(config.stats.baseDate);

// Base numbers as of the base date (TODAY)
const BASE_STATS = {
  clients: 700,  // Fixed value - no daily increment
  spaces: 20000,
  years: 6,
  satisfaction: 99
};

// Daily increment rates
const DAILY_INCREMENT = {
  clients: 0,      // No increment for clients (keeping at 700+)
  spaces: 26       // +26 spaces per day
};

/**
 * Calculate days elapsed since base date
 */
const getDaysElapsed = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset to start of day
  
  const baseDate = new Date(BASE_DATE);
  baseDate.setHours(0, 0, 0, 0); // Reset to start of day
  
  const diffTime = today - baseDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return Math.max(0, diffDays); // Never negative
};

/**
 * Get current stats with auto-increment
 */
export const getCurrentStats = () => {
  const daysElapsed = getDaysElapsed();
  
  return {
    clients: BASE_STATS.clients, // Fixed at 700+, no daily increment
    spaces: BASE_STATS.spaces + (daysElapsed * DAILY_INCREMENT.spaces),
    years: BASE_STATS.years,
    satisfaction: BASE_STATS.satisfaction
  };
};

/**
 * Format stats for display
 */
export const getFormattedStats = () => {
  const stats = getCurrentStats();
  
  return [
    {
      value: stats.clients,
      suffix: '+',
      label: 'Happy Clients'
    },
    {
      value: stats.spaces,
      suffix: '+',
      label: 'Spaces Cleaned'
    },
    {
      value: stats.years,
      suffix: '+',
      label: 'Years Experience'
    },
    {
      value: stats.satisfaction,
      suffix: '%',
      label: 'Satisfaction Rate'
    }
  ];
};

/**
 * Get specific stat value
 */
export const getStatValue = (statName) => {
  const stats = getCurrentStats();
  return stats[statName];
};

/**
 * Preview future stats (for testing)
 */
export const getStatsFuture = (daysInFuture) => {
  const currentDays = getDaysElapsed();
  return {
    clients: BASE_STATS.clients + ((currentDays + daysInFuture) * DAILY_INCREMENT.clients),
    spaces: BASE_STATS.spaces + ((currentDays + daysInFuture) * DAILY_INCREMENT.spaces),
    years: BASE_STATS.years,
    satisfaction: BASE_STATS.satisfaction
  };
};

// For debugging - log current stats
if (process.env.NODE_ENV === 'development') {
  const stats = getCurrentStats();
  const daysElapsed = getDaysElapsed();
  
  console.log('📊 Auto-Increment Stats System');
  console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  console.log(`📅 Base Date: ${BASE_DATE.toLocaleDateString()}`);
  console.log(`📅 Today: ${new Date().toLocaleDateString()}`);
  console.log(`⏱️  Days Elapsed: ${daysElapsed}`);
  console.log('');
  console.log('Current Stats:');
  console.log(`  👥 Clients: ${stats.clients}+ (fixed - no daily increment)`);
  console.log(`  🏠 Spaces: ${stats.spaces.toLocaleString()}+ (base: ${BASE_STATS.spaces.toLocaleString()}, +${DAILY_INCREMENT.spaces}/day)`);
  console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
}
